export var ENTITY = "task";
export var REDUCER_KEY = "TASK_V2";
export var BASE_PATH_ENTITY_TASKS = "tasks";
export var BASE_PATH_ENTITY_COMMENTS = "comments";
export var GENERATOR_PARAMS = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY_TASKS,
    requestBodyToUtcWhitelist: ["nextReminderDate"],
};
